import { render } from "./ClientEdit.vue?vue&type=template&id=13a060f9&scoped=true"
import script from "./ClientEdit.vue?vue&type=script&lang=js"
export * from "./ClientEdit.vue?vue&type=script&lang=js"

import "./ClientEdit.vue?vue&type=style&index=0&id=13a060f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a060f9"],['__file',"src/components/client/ClientEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13a060f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13a060f9', __exports__)) {
    api.reload('13a060f9', __exports__)
  }
  
  module.hot.accept("./ClientEdit.vue?vue&type=template&id=13a060f9&scoped=true", () => {
    api.rerender('13a060f9', render)
  })

}


export default __exports__